import FingerprintJS from "@fingerprintjs/fingerprintjs";

const DEVICE_ID_STORAGE_KEY = "device_id";

let fingerprintPromise: Promise<string> | null = null;

const loadFingerprint = async () => {
  const agent = await FingerprintJS.load();
  const result = await agent.get();
  return result.visitorId;
};

export const getDeviceId = async () => {
  const cachedDeviceId = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
  if (cachedDeviceId) return cachedDeviceId;

  if (!fingerprintPromise) {
    fingerprintPromise = loadFingerprint();
  }

  try {
    const deviceId = await fingerprintPromise;
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
    return deviceId;
  } catch {
    const fallbackId = crypto.randomUUID();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, fallbackId);
    return fallbackId;
  }
};
